import React from 'react';
import Navigation from './components/Navigation';

const sections = [
  {
    title: '1. Information We Collect',
    content: '[PLACEHOLDER]',
  },
  {
    title: '2. How We Use Your Information',
    content: '[PLACEHOLDER]',
  },
  {
    title: '3. Sharing of Information',
    content: '[PLACEHOLDER]',
  },
  {
    title: '4. Cookies & Tracking',
    content: '[PLACEHOLDER]',
  },
  {
    title: '5. Data Retention',
    content: '[PLACEHOLDER]',
  },
  {
    title: '6. Your Rights',
    content: '[PLACEHOLDER]',
  },
  {
    title: '7. Security',
    content: '[PLACEHOLDER]',
  },
  {
    title: '8. Changes to This Policy',
    content: '[PLACEHOLDER]',
  },
  {
    title: '9. Contact',
    content: '[PLACEHOLDER]',
  },
];

function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation />

      <div className="max-w-3xl mx-auto px-4 py-12">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Privacy Policy</h1>
          <p className="text-sm text-gray-500">Last updated: [DATE]</p>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 divide-y divide-gray-100">
          {sections.map(({ title, content }) => (
            <div key={title} className="px-6 py-6">
              <h2 className="text-base font-semibold text-gray-900 mb-2">{title}</h2>
              <p className="text-sm text-gray-600 leading-relaxed">{content}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
